import {
  state,
  style,
  animate,
  trigger,
  transition,
  AnimationTriggerMetadata,
} from '@angular/animations';

export const snDrawerTransition: AnimationTriggerMetadata = trigger('snDrawerTransition', [
  state(
    'open',
    style({
      transform: 'none',
      visibility: 'visible',
    }),
  ),
  state(
    'void',
    style({
      visibility: 'hidden',
    }),
  ),
  transition('void <=> open', animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
]);
